const selectedProfile = "production";

const config = {

    local: {
        AUTH_API_BASE_URL: "http://localhost:8080",
        PUBLIC_API_BASE_URL: "http://localhost:8081",
        STATIC_API_BASE_URL: "http://localhost:3006", 
        MITIGATE_CLIENT_PORTAL_URL: "http://localhost:3003", 
        OAUTH_CLIENT_ID: "mitigate-dashboard-test-client-id"
    },

    test: {
        AUTH_API_BASE_URL: "https://auth.cygnus-test.com",
        PUBLIC_API_BASE_URL: "https://public.cygnus-test.com",
        STATIC_API_BASE_URL: "https://static.cygnus-test.com", 
        MITIGATE_CLIENT_PORTAL_URL: "https://mitigate.cygnus-test.com", 
        OAUTH_CLIENT_ID: "mitigate-dashboard-test-client-id"
    },

    production: {
        AUTH_API_BASE_URL: "https://auth.cygnus-aisp.com",
        PUBLIC_API_BASE_URL: "https://public.cygnus-aisp.com",
        STATIC_API_BASE_URL: "https://static.cygnus-aisp.com", 
        MITIGATE_CLIENT_PORTAL_URL: "https://mitigate.cygnus-aisp.com", 
        OAUTH_CLIENT_ID: "mitigate-dashboard-test-client-id"
    }

};

const I18_LANGUAGE = "18Language";

export {
    config, selectedProfile, I18_LANGUAGE
}
export default() => {
    return true;
}